import type { IconData } from '@stacksjs/iconify-core'

export const fahrenheitSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5 7a2 2 0 1 1 4 0a2 2 0 0 1-4 0m2-6a6 6 0 1 0 0 12A6 6 0 0 0 7 1m10.337 5.313c1.24-1.225 2.91-1.813 4.947-1.813h19.773c1.825 0 3.787.931 4.215 2.915c.154.713.228 1.439.228 2.126c0 1.714-.397 3.087-1.287 4.017c-.834.876-1.967 1.29-3.335 1.29H28.19v6.546h11.57c1.823 0 3.795.917 4.263 2.886a9 9 0 0 1 .247 2.088c0 1.708-.394 3.066-1.292 3.956c-.833.872-1.964 1.285-3.329 1.285H28.325v9.958c0 2.464-1.677 4.75-4.258 4.89c-.579.03-1.154.043-1.716.043c-2.37 0-4.167-.4-5.255-1.32l-.01-.01c-1.102-.985-1.586-2.608-1.586-4.712V11.21c0-2.018.597-3.67 1.837-4.897\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default fahrenheitSolid
